import { CalendarDate, type DateValue } from '@internationalized/date'
import dayjs from 'dayjs'
import localeSl from 'dayjs/locale/sl'
import advancedFormat from 'dayjs/plugin/advancedFormat'

import { nullDate } from '@/libs/helpers.ts'
dayjs.extend(advancedFormat)
dayjs.locale(localeSl)

export const formatDate = (date: Date | number | string, showTime = true) => {
    const formatToken = showTime ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY'
    return dayjs(date).format(formatToken)
}

export const isDateNull = (date: Date | number | string) => {
    return dayjs(date).format('YYYY-MM-DD') === nullDate
}

/**
 * Nuxt UI's date components model their value as an @internationalized/date
 * object, while our API payloads and query strings stay ISO strings. These two
 * helpers are the conversion boundary — see vue-spec libraries.md.
 */
export const toCalendarDate = (value?: Date | string | null): CalendarDate | undefined => {
    if (!value) return undefined
    const parsed = dayjs(value)
    if (!parsed.isValid()) return undefined
    return new CalendarDate(parsed.year(), parsed.month() + 1, parsed.date())
}

export const fromCalendarDate = (value?: DateValue | null): string => {
    if (!value) return ''
    return `${value.year}-${String(value.month).padStart(2, '0')}-${String(value.day).padStart(2, '0')}`
}

export default dayjs
